import {
  SlTextarea
} from "./chunk.J7HXHHT3.js";

// src/components/textarea/textarea.ts
var textarea_default = SlTextarea;
SlTextarea.define("sl-textarea");

export {
  textarea_default
};
